import { render } from "./photoComponent.vue?vue&type=template&id=60a2dec7&scoped=true"
import script from "./photoComponent.vue?vue&type=script&lang=js"
export * from "./photoComponent.vue?vue&type=script&lang=js"

import "./photoComponent.vue?vue&type=style&index=0&id=60a2dec7&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a2dec7"]])

export default __exports__